import { useMutation } from '@tanstack/react-query';

import { generateConceptReply } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

export default function useGenerateConceptReply() {
  return useMutation({
    mutationFn: ({
      body,
      actions,
      emailId,
      prompt,
    }: {
      actions?: string[];
      body?: string;
      emailId: string;
      prompt?: string;
    }) =>
      generateConceptReply(
        {
          params: {
            path: { email_id: emailId },
            query: {},
          },
          body: {
            action_ids: actions,
            current_concept_reply: body,
            prompt,
          },
        },
        wgApi,
      ),
  });
}
